import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface Category {
  id: string;
  name: string;
  slug: string;
  listing_type: 'event' | 'experience';
}

export const useCategories = (type?: 'event' | 'experience') => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, [type]);

  const fetchCategories = async () => {
    let query = supabase
      .from('categories')
      .select('id, name, slug, listing_type')
      .eq('is_active', true)
      .order('display_order');

    if (type) {
      query = query.eq('listing_type', type);
    }

    const { data, error } = await query;

    if (!error && data) {
      setCategories(data as Category[]);
    }
    setLoading(false);
  };

  const getCategoryNames = (listingType: 'event' | 'experience') => {
    return categories
      .filter(c => c.listing_type === listingType)
      .map(c => c.name);
  };

  return {
    categories,
    loading,
    eventCategories: getCategoryNames('event'),
    experienceCategories: getCategoryNames('experience'),
    refetch: fetchCategories,
  };
};
